module.exports = __webpack_public_path__ + "img/linge.b580d98a.png";